<!--我的页面-->
<template>
	<div class="id">
		<div class="navBar" @click="$router.back()">
			<van-icon name="arrow-left" />
			{{ $t('闪兑') }}
		</div>
		<div class="boxTop">
			<div class="title">
				<div> {{ $t('从') }}</div>
				<div> {{ $t('可用') }}：{{ fromCurrency.value }}{{ fromCurrency.text || 'USDT' }}</div>
			</div>
			<div class="universal" @click="showPicker = true">
				<div>{{ fromCurrency.text || $t('请选择') }}</div>
				<van-icon name="arrow-down" />
			</div>

			<div class="title">
				<div>{{ $t('至') }}</div>
				<div>{{ $t('可用') }}：{{ toCurrency.value }}{{ toCurrency.text || 'USDT' }}</div>
			</div>
			<div class="universal" @click="toPicker = true">
				<div>{{ toCurrency.text || $t('请选择') }}</div>
				<van-icon name="arrow-down" />
			</div>

			<div class="title">{{ $t('兑换数量') }}</div>
			<div class="universal">
				<van-field v-model="quantity" :placeholder="$t('请输入兑换数量')" :border="false" />
				<div style="color: #07ecfe;white-space: nowrap;" @class="allCk">{{ $t('全部') }}</div>
			</div>

			<!-- <div style="padding-top: 8px;color: #999999;">{{ quantity || 0 }} USDT</div>
            <div class="proportion">
                当前兑换价格1USDT ≈ 1USDT
            </div> -->
			<van-button class="btn" type="primary" @click="submit">{{ $t('兑换') }}</van-button>
		</div>

		<div class="boxTop">
			<div style="font-size: 18px;padding-top: 10px;">{{ $t('闪兑记录') }}</div>
			<div class="table">
				<!-- 表头 -->
				<van-row class="header">
					<van-col span="8" class="vanItem">{{ $t('时间') }}</van-col>
					<van-col span="8" class="vanItem">{{ $t('币种') }}</van-col>
					<van-col span="8" class="vanItem">{{ $t('数量') }}</van-col>
				</van-row>
				<!-- 数据 -->
				<div class="scroll">
					<van-row v-for="item in users" :key="item.id" class="row">
						<van-col span="8" class="trade">
							{{ item.createtime_text }}
						</van-col>
						<van-col span="8" class="trade" style="color: #07ecfe;">
							{{ item.coin_name }}
						</van-col>
						<van-col span="8" class="trade" :style="{ color: item.money > 0 ? '#07ecfe' : '#ff4834' }">
							{{ item.money }}
						</van-col>
					</van-row>
				</div>
			</div>
		</div>
		<van-popup v-model="showPicker" position="bottom">
			<van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" :confirm-button-text="$t('确认')" :cancel-button-text="$t('取消')"/>
		</van-popup>
		<van-popup v-model="toPicker" position="bottom">
			<van-picker show-toolbar :columns="toColumns" @confirm="toConfirm" @cancel="toPicker = false" :confirm-button-text="$t('确认')" :cancel-button-text="$t('取消')"/>
		</van-popup>

	</div>
</template>
<script>
	import {
		get,
		post
	} from '@/http/request'
	import apis from '@/http/api'
	export default {
		components: {

		},
		data() {
			return {
				quantity: '',
				showPicker: false,
				toPicker: false,
				columns: [],
				toColumns: [],
				fromCurrency: {
					text: '',
					value: '0',
					id: ""
				},
				toCurrency: {
					text: '',
					value: '0',
					id: ''
				},
				users: [],
			};
		},
		mounted() {
			this.exchangeData()
			this.exchangeRec()
		},
		beforeUnmount() {},
		methods: {
			allCk() {
				this.quantity = this.fromCurrency.value
			},
			//闪兑 下拉框
			async exchangeData() {
				const res = await get(apis.exchangeData)
				if (res.code == 1) {
					this.columns = res.data.map(item => ({
						text: item.symbol,
						...item
					}))
					this.toColumns = res.data.map(item => ({
						text: item.symbol,
						...item
					}))
					return
				}
			},
			//闪兑历史数据
			async exchangeRec() {
				const res = await get(apis.exchangeRec, {
					limit: 9999,
					showLoading: false
				})
				if (res.code == 1) {
					this.users = res.data.list
					return
				}
			},
			//提交
			async submit() {
				const res = await post(apis.exchangeSubmit, {
					from: this.fromCurrency.id,
					to: this.toCurrency.id,
					amount: this.quantity
				})
				if (res.code == 1) {
					this.$toast(res.msg);
					setTimeout(() => {
						this.exchangeRec()
					}, 1200)
					return
				}
			},
			onConfirm(value) {
				this.fromCurrency = value
				this.showPicker = false
			},
			toConfirm(value) {
				this.toCurrency = value
				this.toPicker = false
			}

		},
	};
</script>
<style lang="less" scoped>
	::v-deep .van-cell {
		padding: 0;
	}

	.id {
		color: #fff;
		padding: 0 15px;
		padding-bottom: 20px;
		padding-top: 50px;
		font-size: 14px;

		.navBar {
			background-color: #090d13;
			padding: 15px 10px;
			font-size: 18px;
			font-weight: 700;
			border-radius: 4px;
		}

		.boxTop {
			padding: 10px;
			border-radius: 10px;
			border: 1px solid #2c2c3e;
			margin-top: 20px;
		}



		.title {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-top: 20px;
			font-weight: 700;
		}

		.btn {
			width: 100%;
			margin: 20px 0;
			background-color: #07ecfe;
			border-radius: 5px;
			color: #000;
		}

		.table {
			background: #000;
			color: #fff;
			margin-top: 20px;
			font-size: 12px;

			.header {
				background: #1c222c;
				padding: 10px 0;
				border-radius: 5px;

				.vanItem {
					text-align: center;
				}
			}

			.scroll {
				overflow-y: auto;
				height: 45vh;
				scrollbar-width: none;
				/* Firefox */
				-ms-overflow-style: none;
				/* IE/Edge */
			}

			.row {
				border-bottom: 1px solid #222b39;
				padding: 10px 0px;
				display: flex;
				align-items: center;
				font-size: 11px;

				.trade {
					text-align: center;
				}
			}
		}



		.proportion {
			text-align: center;
			margin-top: 20px;
		}

		.universal {
			padding: 10px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			border: 1px solid #3a3f47;
			margin-top: 10px;
			border-radius: 5px;
		}

	}
</style>